module.exports = __webpack_public_path__ + "static/media/people-matters.653f9256.png";